/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./headMobile.vue?vue&type=template&id=56dd2b38&scoped=true"
import script from "./headMobile.vue?vue&type=script&lang=js"
export * from "./headMobile.vue?vue&type=script&lang=js"
import style0 from "./headMobile.vue?vue&type=style&index=0&id=56dd2b38&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56dd2b38",
  null
  
)

export default component.exports